export default {
  getCategoryCodeById: state=>id=>{
    var ind= state.items.findIndex(x=>x.id==id);
    if(ind!=-1&&ind!=undefined){
      return state.items[ind].requestCategoryCode
    }
    else return null
  }
}
